// extracted by mini-css-extract-plugin
export default {"container":"iI-z","header":"jI-z","details":"kI-z","link":"lI-z"};